import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Slide } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import Person from '@material-ui/icons/Person';

const styles = () => ({
  dialog: {
    zIndex: 1320, // necessário pois deve ser carregado sobre um Modal
  },
});

function Transition (props) {
  return <Slide direction='down' {...props} />;
}

class DialogSlideEquipe extends React.Component {
  render () {
    const { open, handleClose, title, equipe, classes } = this.props;

    return (
      <React.Fragment>
        <Dialog
          open={open}
          className={classes.dialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
        >
          <DialogTitle>
            {title[0]}: {title[1]}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <List>
              {equipe.map((papel, idx) =>
                <ListItem key={idx}>
                  <ListItemIcon >
                    <Person />
                  </ListItemIcon>
                  <ListItemText>
                    {papel}
                  </ListItemText>
                </ListItem>
              )}
            </List>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button id={'fechar'} onClick={handleClose} color='primary'>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(DialogSlideEquipe);
